import { useMemo } from 'react';
import styled from 'styled-components';
import { formatDate } from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';
import { classnamePrefix } from '../../../../constants';
import { Image } from '../Image';

export const CommentsItem = ({ data }) => {
  const {
    text,
    user: {
      name,
      pictures: { sizes },
      link
    },
    created_on: createdTime
  } = data;

  const { lang } = useSettings();
  const locale = lang ?? 'en';

  const formattedDate = useMemo(
    () => formatDate({ locale, date: new Date(createdTime) }),
    [createdTime, locale]
  );

  return (
    <Component>
      <ImageLink href={link} target="_blank" rel="nofollow noreferrer">
        <Image imagesArray={sizes}></Image>
      </ImageLink>

      <Info>
        <Author>
          <AuthorNameLink href={link} target="_blank" rel="nofollow noreferrer">
            {name}
          </AuthorNameLink>

          <AuthorDate>{formattedDate}</AuthorDate>
        </Author>

        <Text>{text}</Text>
      </Info>
    </Component>
  );
};

const Component = styled.div.attrs({
  className: `${classnamePrefix}-comments-item-component`
})`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  max-width: 600px;
  width: 100%;

  &:not(:last-child) {
    margin-bottom: 20px;
  }
`;

const Info = styled.div.attrs({
  className: `${classnamePrefix}-comments-item-info`
})`
  margin-left: 12px;
`;

const Author = styled.div.attrs({
  className: `${classnamePrefix}-comments-item-author`
})`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

const AuthorNameLink = styled.a.attrs({
  className: `${classnamePrefix}-comments-item-authorName`
})`
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: rgb(26, 46, 59);
`;

const AuthorDate = styled.div.attrs({
  className: `${classnamePrefix}-comments-item-authorDate`
})`
  margin-left: 12px;
  font-size: 12px;
  line-height: 20px;
  color: rgba(26, 46, 59, 0.5);
`;

const ImageLink = styled.a.attrs({
  className: `${classnamePrefix}-comments-item-image`
})`
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  position: relative;
  border-radius: 50%;
  overflow: hidden;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    border: solid 1px rgba(17, 17, 17, 0.1);
    border-radius: 50%;
  }
`;

const Text = styled.div.attrs({
  className: `${classnamePrefix}-comments-item-text`
})`
  font-size: 14px;
  line-height: 20px;
  color: rgb(26, 46, 59);
`;
